import { useApiRequestHelper } from '@/composables/useApiRequestHelper.js'
import { useRedirectToError } from '@/composables/useRedirectToError'
import { useAppStore } from '@/stores/AppStore'
import { useAuthStore } from '@/stores/authenticated/AuthStore.js'
import { useUnauthenticatedTokenStore } from '@/stores/unauthenticated/UnauthenticatedTokenStore.js'
import { useRoute, useRouter } from 'vue-router'

export const unauthenticatedMiddleware = async (to, from, next) => {
  const route = useRoute()
  const token = route.params.token
  const appStore = useAppStore()
  const unauthenticatedTokenStore = useUnauthenticatedTokenStore()
  const router = useRouter()

  // all of these should have been set at the index redirect at the start of the unauthenticated flow
  if (!appStore.apiUrl || !unauthenticatedTokenStore.token || !unauthenticatedTokenStore.tokenId) {
    await useRedirectToError(router).redirect()

    return next(false)
  }

  // set the url in the api request helper
  const { setApiUrlUnauthenticated } = useApiRequestHelper()
  await setApiUrlUnauthenticated(appStore.apiUrl, token)

  // check we're not logged in from a previous session
  useAuthStore().reset()

  // get the token record
  await unauthenticatedTokenStore.refresh()
  const engineerCheckInAccessToken = unauthenticatedTokenStore.engineerCheckInAccessToken

  if (!allowBackNavigation(from)) {
    return next(false)
  }

  const redirect = verificationRedirect(unauthenticatedTokenStore.engineerCheckInAccessToken, to)

  if (redirect) {
    return next(redirect)
  }

  return next()
}

function allowBackNavigation(from) {
  const blocked = ['auth.verification.methods.confirmed', 'auth.verification.sent']

  return !blocked.includes(from.name)
}

function verificationRedirect(token, to) {
  if (!to.name?.startsWith('auth.verification.')) {
    return null
  }

  if (!token.contractor) {
    return { name: 'auth.contractor' }
  }

  if (!token.user) {
    return { name: 'auth.user' }
  }

  return null
}
